<template>
  <div class="krpanoWrap">
    <div id="pano"></div>
    <div class="mask" v-if="showRemind" @click="playaudio">
      <div class="remindBtn">
        <!-- <div class="know">知道了</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { loadScript } from '@/utils/loadScript'

// import { userInfo } from '@/utils/mixins.js'
export default {
  // mixins: [userInfo],
  data() {
    return {
      krpano: null,
      showRemind: true,
      publicPath: process.env.BASE_URL,
      playSound: false
    }
  },
  created() {
    this.appSource()
  },
  mounted() {
    this.init()
    window.addEventListener('setItemEvent', this.handleFn)

    // loadScript(`https://edu.njzq.cn/wx/get-share-config?url=${encodeURIComponent(location.href)}`)
    //   .then(() => {
    //     try {
    //       console.log('调用config成功----------')
    //       wx.ready(function() {
    //         this.krpano.call('playsound(bggsnd123);')
    //       })
    //     } catch (err) {
    //       throw new Error(err)
    //     }
    //   })
    //   .catch(err => {
    //     console.log(err)
    //   })
  },
  watch: {
    playSound(val) {
      if (val) {
        console.log(33333)
        setTimeout(() => {
          this.krpano.call('playsound(bggsnd123)')
        }, 500)
      }
    }
  },
  methods: {
    init() {
      let _this = this
      embedpano({
        // swf:
        //     "https://view.horsevision.cn/h5/tkk/huataiPrice/krpano/tour.swf",
        // xml:
        //     "https://view.horsevision.cn/h5/tkk/huataiPrice/krpano/tour.xml",
        swf: `${process.env.BASE_URL}vtour3/tour.swf`,
        xml: `${process.env.BASE_URL}vtour3/tour.xml`,
        target: 'pano',
        html5: 'prefer',
        passQueryParameters: true,
        onready: _this.callback
      })
    },

    // 全景初始化完成的回调函数
    callback(a) {
      this.krpano = document.querySelector('#krpanoSWFObject')
      this.krpano.call('resumesound(bggsnd123);')
    },
    handleFn(e) {
      console.log(e, 33333)
      if (e.key == 'scene1') {
        console.log(88888888888888)
        this.playSound = Math.random(1, 5)
        localStorage.removeItem('scene1')
      }
    },
    playaudio() {
      this.showRemind = false
      this.krpano.call('playsound(bggsnd123);')
    },

    // 判断是苹果手机还是安卓
    appSource() {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        this.showRemind = true
      }
    }
  },
  // 视频回退后，恢复解说词
  // watch: {
  //   $route(to, from) {
  //     console.log(to.path, from.path, '监听路由变化')
  //     if (from.path == '/vtourVideo' && to.path == '/krpano') {
  //       this.krpano.call('resumesound(curaudio);')
  //     }
  //   }
  // },
  destroyed() {
    // this.krpano.call('stopallsounds();')
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
